import { branch, renderNothing } from 'recompose'
import { googleAPIReadySelector } from 'map/selectors'
import { loadGoogleAPI } from 'map/actions'
import { loadOnMount } from 'shared/hoc'
import Map from 'shared/components/Map'

const $Map = compose(
    connect(
        createStructuredSelector({
            apiReady: googleAPIReadySelector,
        }),
        { loadGoogleAPI }
    ),
    loadOnMount(
        'loadGoogleAPI',
        () => [],
        props => !props.apiReady
    ),
    branch(props => !props.apiReady, renderNothing)
)(Map)

export { $Map as Map }
